/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.FameAdvantage {
    import EmployeeEntityTypeEnum = Meevo.Model.EmployeeEntityTypeEnum;

    const CHUNK_SIZE = 10;
    const EMPTY_RESULT = {
        addedMeevoStudents: [],
        errors: [],
        updatedMeevoStudents: []
    };

    export class ImportSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        public importTypeModel: FameAdvantageImportTypeEnum = FameAdvantageImportTypeEnum.Add;
        public importType: FameAdvantageImportTypeEnum = FameAdvantageImportTypeEnum.Add;
        public studentsIsLoaded: boolean = false;
        public model: IImportAdvantageData[] = [];
        public studentCriteria = {
            showEmployeesOnly: true,
            employeeEntityTypeEnum: EmployeeEntityTypeEnum.Student,
            excludeIdList: []
        };

        public password: string = null;
        public studentTemplate: IAppliedTemplate = null;
        public importTypeOptions = [
            {label: 'LABEL_STUDENTS_RECORDS_TO_BE_ADDED', value: FameAdvantageImportTypeEnum.Add},
            {label: 'LABEL_STUDENTS_RECORDS_TO_BE_UPDATED', value: FameAdvantageImportTypeEnum.Update},
        ];

        protected dataService: IFameAdvantageApi;

        public get passwordIsSet(): boolean {
            return !!this.password;
        }

        public get templateIsSet(): boolean {
            return !!this.studentTemplate;
        }

        public get isValidModel(): boolean {
            if (this.isAdding) {
                return this.passwordIsSet && this.templateIsSet;
            } else {
                return true;
            }
        }

        public get isAdding(): boolean {
            return this.importType === FameAdvantageImportTypeEnum.Add;
        }

        public get isUpdating(): boolean {
            return this.importType === FameAdvantageImportTypeEnum.Update;
        }

        private get importModel(): IImportModel {
            return {
                appliedTemplates: this.studentTemplate ? [this.studentTemplate] : null,
                templateId: this.studentTemplate ? this.studentTemplate.templateId : null,
                password: this.password,
                fameStudents: this.prepareStudentsToImport(this.model),
            };
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: IFameAdvantageApi,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            sectionSecurityKey: string,
            private modalService: Meevo.Components.Modal.IModalService,
            private busyService: Meevo.Components.Busy.IBusyService,
        ) {
            super(
                sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                noun,
                identityService,
                sectionSecurityKey,
            );
        }

        public loadStudents(): void {
            if (this.studentsIsLoaded) {
                this.modalService.confirm('MESSAGE_CONFIRM_LOAD_ADVANTAGE_STUDENTS', Meevo.Components.Modal.ModalTranslationModes.Translate, false, {
                    modalClass: 'modal-alert'
                })
                    .then((res) => {
                        if (res) {
                            this.importType = this.importTypeModel;
                            this.loadData();
                        }
                    });
            } else {
                this.importType = this.importTypeModel;
                this.loadData();
            }
        }

        public setTemporaryPassword(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/components/changePassword/changePassword.html',
                locals: {
                    model: null,
                    userId: null,
                    userName: null,
                    requireChangePassword: false,
                    headerTitle: 'LABEL_SET_TEMPORARY_PASSWORD',
                    isHandleRequest: true,
                },
                controller: 'meevo.changePassword.ChangePasswordController',
                controllerAs: 'changePassword',
                bindToController: true
            };

            this.modalService.showCustom(options)
                .then((newPassword: string) => {
                    if (!!newPassword) {
                        this.password = newPassword;
                    }
                });
        }

        public applyTemplate(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/fameAdvantage/modals/apply-student-template/apply-student-template.html',
                controller: 'meevo.plugins.fameAdvantage.ApplyStudentTemplateController',
                controllerAs: '$ctrl',
                bindToController: true,
            };
            this.modalService.showCustom(options)
                .then((template: IAppliedTemplate) => {
                    this.studentTemplate = template;
                });

        }

        public studentSelected(): void {
            this.studentCriteria.excludeIdList = this.model.filter((item) => !!item.student).map((item) => item.student.id);
        }

        public importStudents(): void {
            this.confirmImport().then(() => {
                this.busyService.start();
                this.busyService.setProgress(0);
                this.importStudentsInChunks(this.importModel)
                    .then((res) => {
                        this.clear();
                        this.showImportResult(res);
                    })
                    .finally(() => this.busyService.stop());
            }, null);
        }

        private loadData(): ng.IPromise<void> {
            this.busyService.start();

            return this.testConnection()
                .then(() => {
                    if (this.isAdding) {
                        return this.dataService.loadStudentsFromAdvantageForImport();
                    }

                    return this.dataService.loadStudentsFromAdvantageForUpdate();
                }, null)
                .then((data) => {
                    this.model = data;
                    this.studentsIsLoaded = true;
                    this.password = null;
                    this.studentTemplate = null;
                })
                .catch((err) => {
                    if (!!err.responseStatus) {
                        this.modalService.error(err.responseStatus.message);
                    }
                })
                .finally(() => this.busyService.stop());
        }

        private prepareStudentsToImport(fameData: IImportAdvantageData[]): IFameStudent[] {
            return fameData.map((item) => {
                if (!!item.student) {
                    item.fameStudent.meevoStudentId = item.student.id;
                }

                return item.fameStudent;
            });
        }

        private testConnection(): ng.IPromise<void> {
            return this.dataService.getSettings()
                .then((settings) => this.dataService.testConnection({
                    username: settings.userName,
                    password: settings.password,
                    advantageAPIURL: settings.advantageAPIURL,
                    tenantName: settings.tenantName
                }))
                .then((isSuccess: boolean) => {
                    if (isSuccess) {
                        return;
                    } else {
                        this.modalService.alert('MESSAGE_UNSUCCESSFUL_ADVANTAGE_CONNECT');

                        throw Error('Unsuccessful connect to Advantage');
                    }

                }, null);
        }

        private clear(): void {
            this.model = [];
            this.studentsIsLoaded = false;
            this.password = null;
            this.studentTemplate = null;
        }

        private mapResults(result: IImportRes): IImportResult[] {
            return [
                ...result.addedMeevoStudents.map((item) => ({
                    studentId: item.externalStudentId,
                    firstName: item.firstName,
                    lastName: item.lastName,
                    status: ImportResultEnum.Successful,
                    message: ''
                })),
                ...result.updatedMeevoStudents.map((item) => ({
                    studentId: item.externalStudentId,
                    firstName: item.firstName,
                    lastName: item.lastName,
                    status: ImportResultEnum.Updated,
                    message: ''
                })),
                ...result.errors.map((item) => ({
                    studentId: item.fameStudent.studentId,
                    firstName: item.fameStudent.firstName,
                    lastName: item.fameStudent.lastName,
                    status: ImportResultEnum.Failed,
                    message: item.errorMessage
                }))
            ];
        }

        private importStudentsInChunks(importModel: IImportModel, chunk: number = 0, result: IImportRes = {...EMPTY_RESULT}): ng.IPromise<IImportRes> {
            let data = {
                ...importModel,
                fameStudents: importModel.fameStudents.slice(chunk, chunk + CHUNK_SIZE)
            };
            let promise: ng.IPromise<IImportRes> = this.isAdding
                ? this.dataService.importStudents(data)
                : this.dataService.updateStudents(data);

            return promise.then((res) => {
                result.addedMeevoStudents = [...result.addedMeevoStudents, ...res.addedMeevoStudents];
                result.errors = [...result.errors, ...res.errors];
                result.updatedMeevoStudents = [...result.updatedMeevoStudents, ...res.updatedMeevoStudents];

                if (chunk >= importModel.fameStudents.length) {
                    return result;
                }

                chunk += CHUNK_SIZE;
                this.busyService.setProgress(chunk / importModel.fameStudents.length * 100)

                return this.importStudentsInChunks(importModel, chunk, result);
            });
        }

        private showImportResult(res: IImportRes) {
            this.modalService.message('MESSAGE_IMPORT_RECORDS_SUCCESSFULLY')
                .then(() => {
                    let options: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: 'app/plugins/fameAdvantage/modals/import-result/import-result.html',
                        locals: {
                            items: this.mapResults(res)
                        },
                        controller: 'meevo.plugins.fameAdvantage.ImportResultController',
                        controllerAs: '$ctrl',
                        bindToController: true
                    };
                    this.modalService.showCustom(options);
                });
        }

        private confirmImport(): ng.IPromise<void> {
            let confirmPromise = this.isAdding
                ? this.modalService.warning('MESSAGE_CONFIRM_IMPORT_RECORDS', Meevo.Components.Modal.ModalTranslationModes.Translate, false, {
                    showCancelButton: true,
                    okButtonContentKey: 'LABEL_YES',
                    cancelButtonContentKey: 'LABEL_NO',
                    cancelButtonHotKey: 'MODAL_NO_BUTTON',
                    okButtonHotKey: 'MODAL_YES_BUTTON'
                })
                : this.modalService.confirm('MESSAGE_CONFIRM_IMPORT_RECORDS_FOR_UPDATE', Meevo.Components.Modal.ModalTranslationModes.Translate, false, {
                    modalClass: 'modal-alert'
                });

            return confirmPromise.then((res) => {
                if (res) {
                    return;
                }
                throw Error('Cancel confirm');
            });
        }
    }
}
